
/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains EmployeeUtilizationTable using MUI components
  ------------------------------------------------------------------------------------------------------- */

import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import jsPDF from "jspdf";
import "jspdf-autotable";

import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination';
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable';
import { handlePaginationEntries } from '../../../../utils/pagination';
import Loader from '../../../../Components/Loader/Loader';
import { get_combined_employee_reports_with_pagination } from '../../../../config/ReportApis/employeeReportApis';
import WorkforceCombinedReportFilter from '../WorkforceCombinedReportFilter/WorkforceCombinedReportFilter';
import useDataExport from '../../../../utils/useDataExport';

function WorkforceCombinedReportTable() {

    const [WorkforceCombinedList, setWorkforceCombinedList] = useState([]);

    // Calculate the total pages based on the number of items and items per page
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });


    const [filterValues, setFilterValues] = useState({}); // Define filter values state
    const [isLoading, setIsLoading] = useState(false); // Loader state

    // const [isExportingPDF, setIsExportingPDF] = useState(false); // Exporting state

    // const [isExportingExcel, setIsExportingExcel] = useState(false);

    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Employee Name", key: "FSE_Name" },
        { title: "Site Name", key: "Site_Name" },
        { title: "Job Type", key: "Job_Type" },
        // { title: "Report Generated By", key: "Report_Generated_By" },
        { title: "Services Attended", key: "Service_Attended" },
        { title: "Reports Attended", key: "Reports_Attended" },

        { title: "Total Man-days", key: "Mandays" },


    ].filter(column => column.key !== "actions"); //removes the "Actions" column when hasActionPermissions is false

    // Map the schedule data into table rows
    const rows = () => WorkforceCombinedList?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        FSE_Name: item.FSE_Name,
        Job_Type: item.Job_Type,
        Site_Name: item?.Site_Name,
        Mandays: item?.Mandays,
        Report_Generated_By: `${item?.Report_Generated_By}`,

        Reports_Attended: `${item?.Reports_Attended}`,
        Service_Attended: `${item?.Schedules}`,

    }));
    const headers = columns.map(col => col.title);

    const mapDataFn = (item, index) => [
        index + 1,
        item?.FSE_Name || "—",
        item?.Site_Name || "—",
        item?.Job_Type || "—",
        item?.Schedules || 0,
        item?.Reports_Attended || 0,
        item?.Mandays || 0,
    ];
    const {
        handleExportExcel,
        handleExportPDF,
        isExportingExcel,
        isExportingPDF,
    } = useDataExport(
        get_combined_employee_reports_with_pagination,
        mapDataFn,
        headers,
        "Employee Report"
    );

    // Fetch schedule data on page change or refresh
    useEffect(() => {
        getFutureScheduleReport();
    }, [pageNumber, totalItemPerPage, filterValues]);


    // Fetch schedule data from API
    const getFutureScheduleReport = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);

        // Append filter values to formData
        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

        try {
            setIsLoading(true)
            const response = await get_combined_employee_reports_with_pagination(formData);
            if (response?.status === "success") {
                const data = response?.data;
                setWorkforceCombinedList(data?.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setWorkforceCombinedList([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    // Handle search filter change
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
    };

    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);

    // // EXPORT TO EXCEL
    // const handleExportExcel = async () => {
    //     try {
    //         setIsExportingExcel(true)
    //         const formData = new FormData();
    //         formData.append('page', pageNumber);
    //         formData.append('pageItemcount', totalItemPerPage);

    //         Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

    //         const response = await get_combined_employee_reports_with_pagination(formData);
    //         if (response?.status === "success") {
    //             const exportData = response.data?.data || [];

    //             if (exportData.length === 0) {
    //                 alert("No data available to export.");
    //                 return;
    //             }

    //             // Define column headers and map data
    //             const tableHeaders = [
    //                 "#",
    //                 "Employee Name",
    //                 "Site Name",
    //                 "Job Type",
    //                 "Services Attended",
    //                 "Reports Attended",
    //                 "Total Man-days"
    //             ];

    //             const tableData = exportData.map((item, index) => [
    //                 index + 1, // Sl. No
    //                 item?.FSE_Name || "—",
    //                 item?.Site_Name || "—",
    //                 item?.Job_Type || "—",
    //                 item?.Schedules || 0,
    //                 item?.Reports_Attended || 0,
    //                 item?.Mandays || "—",
    //             ]);


    //             // Combine title + headers + data
    //             const sheetData = [
    //                 ["Employee Report"], // Title row
    //                 [],                  // Empty row for spacing
    //                 tableHeaders,        // Header row
    //                 ...tableData,        // Data rows
    //             ];

    //             // Create worksheet
    //             const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    //             // Merge the title across all columns (A1 → G1)
    //             const totalColumns = tableHeaders.length;
    //             worksheet['!merges'] = [
    //                 { s: { r: 0, c: 0 }, e: { r: 0, c: totalColumns - 1 } } // Merge A1:G1
    //             ];

    //             // Apply bold, centered style to the title
    //             worksheet['A1'].s = {
    //                 font: { bold: true, sz: 18 },
    //                 alignment: { horizontal: "center" }
    //             };

    //             // Optional: auto-fit column widths
    //             const colWidths = tableHeaders.map(() => ({ wch: 20 }));
    //             worksheet['!cols'] = colWidths;

    //             // Create workbook and export
    //             const workbook = XLSX.utils.book_new();
    //             XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Report");

    //             XLSX.writeFile(workbook, "Employee_Report.xlsx");
    //         }
    //     } catch (error) {
    //         console.error("Excel export failed:", error);
    //     } finally {
    //         setIsExportingExcel(false)
    //     }
    // };

    // // EXPORT TO PDF
    // const handleExportPDF = async () => {
    //     try {
    //         setIsExportingPDF(true)
    //         const formData = new FormData();
    //         formData.append("page", pageNumber);
    //         formData.append("pageItemcount", totalItemPerPage);

    //         Object.keys(filterValues).forEach((key) =>
    //             formData.append(key, filterValues[key])
    //         );

    //         const response = await get_combined_employee_reports_with_pagination(formData);

    //         if (response?.status !== "success") {
    //             alert("No data available to export.");
    //             return;
    //         }

    //         const exportData = response.data?.data || [];
    //         if (!exportData.length) {
    //             alert("No data available to export.");
    //             return;
    //         }

    //         // Initialize PDF in landscape mode
    //         const doc = new jsPDF({ orientation: "landscape" });

    //         // Add Title
    //         doc.setFontSize(16);
    //         doc.setFont("helvetica", "bold");
    //         doc.text("Employee Report", doc.internal.pageSize.getWidth() / 2, 15, {
    //             align: "center",
    //         });

    //         // Table headers with Sl. No
    //         const tableColumn = [
    //             "#",
    //             "Employee Name",
    //             "Site Name",
    //             "Job Type",
    //             "Services Attended",
    //             "Reports Attended",

    //             "Total Man-days",
    //         ];

    //         // Table rows with serial number
    //         const tableRows = exportData.map((item, index) => [
    //             index + 1, // Sl. No
    //             item?.FSE_Name || "—",
    //             item?.Site_Name || "—",
    //             item?.Job_Type || "—",
    //             item?.Schedules || 0,
    //             item?.Reports_Attended || 0,
    //             item?.Mandays || "—",
    //         ]);
    //         // Add table with readable header & body colors
    //         doc.autoTable({
    //             head: [tableColumn],
    //             body: tableRows,
    //             startY: 25,
    //             styles: { fontSize: 9, cellPadding: 3, textColor: 40 }, // darker text
    //             headStyles: {
    //                 fillColor: [180, 180, 180], // darker grey
    //                 textColor: 20, // dark text
    //                 halign: "center",
    //                 fontStyle: "bold",
    //             },
    //             bodyStyles: { halign: "center", valign: "middle", textColor: 30 },
    //             alternateRowStyles: { fillColor: [230, 230, 230] }, // subtle alternate row
    //             margin: { top: 25 },
    //             didDrawPage: (data) => {
    //                 // Page numbers at bottom
    //                 const pageCount = doc.internal.getNumberOfPages();
    //                 doc.setFontSize(10);
    //                 doc.setFont("helvetica", "normal");
    //                 const pageText = `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`;
    //                 doc.text(
    //                     pageText,
    //                     doc.internal.pageSize.getWidth() / 2,
    //                     doc.internal.pageSize.getHeight() - 10,
    //                     { align: "center" }
    //                 );
    //             },
    //         });

    //         doc.save("Employee_Report.pdf");
    //     } catch (error) {
    //         console.error("PDF export failed:", error);

    //     } finally {
    //         setIsExportingPDF(false)
    //     }
    // };

    return (
        <div className='report-table-container'>
            <WorkforceCombinedReportFilter
                tableTitle="Employee Report"
                searchFilter={handleSearchFilter}

                on_change_value={handlePageChange}
                on_page_count_update={handleItemPageCountChange}

                isExportingPDF={isExportingPDF}
                isExportingExcel={isExportingExcel}
                // SET THE EXPORT TO TOTAL ENTRIES IN PAGINATION ONLY FOR EXPORTING ALL DATA
                onExportPDF={() => handleExportPDF(filterValues, { page: 1, pageItemCount: pagination?.totalEntries })}
                onExportExcel={() => handleExportExcel(filterValues, { page: 1, pageItemCount: pagination?.totalEntries })}

            // onExportPDF={handleExportPDF}
            // onExportExcel={handleExportExcel}
            // isExportingPDF={isExportingPDF}
            // isExportingExcel={isExportingExcel}
            />
            <div className="table-container">
                <CustomTable
                    columns={columns}
                    rows={isLoading ? [] : rows()}
                    isCheckbox={false}
                    isLoading={isLoading}
                />
            </div>
            <div className='bottom-container'>
                {isLoading ? <Loader /> : <CustomBottomPagination
                    items_per_page={totalItemPerPage}
                    current_page={pageNumber}
                    total_page_count={totalPages}
                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}
                    pagination={pagination}

                />}
            </div>

            {/* Export loaders */}
            {/* <ExportLoader type="pdf" open={isExportingPDF} />
            <ExportLoader type="excel" open={isExportingExcel} /> */}

        </div>
    );
}

export default WorkforceCombinedReportTable;
